/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Notification for a user based on domain events
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * 
     * @type {number}
     * @memberof Notification
     */
    readonly id: number;
    /**
     * Company that owns this notification
     * @type {number}
     * @memberof Notification
     */
    companyId: number;
    /**
     * User this notification is for
     * @type {number}
     * @memberof Notification
     */
    userId: number;
    /**
     * Type of resource (claim, document, comparison, task, supplement, note, etc.)
     * @type {string}
     * @memberof Notification
     */
    resourceType: string;
    /**
     * ID of the resource this notification references
     * @type {string}
     * @memberof Notification
     */
    resourceId: string;
    /**
     * Human-readable notification message
     * @type {string}
     * @memberof Notification
     */
    message: string;
    /**
     * Additional event-specific data
     * @type {{ [key: string]: any; }}
     * @memberof Notification
     */
    metadata?: { [key: string]: any; } | null;
    /**
     * Dynamically generated frontend URL path (e.g., /claims/123). Not stored in database.
     * @type {string}
     * @memberof Notification
     */
    readonly url?: string | null;
    /**
     * When the notification was marked as read
     * @type {Date}
     * @memberof Notification
     */
    readAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Notification
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Notification
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the Notification interface.
 */
export function instanceOfNotification(value: object): value is Notification {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('resourceType' in value) || value['resourceType'] === undefined) return false;
    if (!('resourceId' in value) || value['resourceId'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function NotificationFromJSON(json: any): Notification {
    return NotificationFromJSONTyped(json, false);
}

export function NotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Notification {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'userId': json['userId'],
        'resourceType': json['resourceType'],
        'resourceId': json['resourceId'],
        'message': json['message'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'url': json['url'] == null ? undefined : json['url'],
        'readAt': json['readAt'] == null ? undefined : (new Date(json['readAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function NotificationToJSON(json: any): Notification {
    return NotificationToJSONTyped(json, false);
}

export function NotificationToJSONTyped(value?: Omit<Notification, 'id'|'url'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'userId': value['userId'],
        'resourceType': value['resourceType'],
        'resourceId': value['resourceId'],
        'message': value['message'],
        'metadata': value['metadata'],
        'readAt': value['readAt'] == null ? undefined : ((value['readAt'] as any).toISOString()),
    };
}

